import React from 'react';

const PageNotFound = () => (
  <div style={{ paddingTop: '10%' }}>
    <h1>404</h1>
  </div>
);

export default PageNotFound;
